import { Box, Typography } from "@mui/material";

interface Props {
  text: string;
  note: string | null | undefined;
}

/** "Gesucht" column: the requested Dienste, with the Notiz of the Anfrage in smaller type below. */
export function ExchangeRequestedCell({ text, note }: Props) {
  return (
    // minWidth releases the flex item's default `min-width: auto`, which the nowrap lines would
    // otherwise push out to their full text width — the cell would hard-clip instead of ellipsising.
    <Box display="flex" flexDirection="column" justifyContent="center" height="100%" minWidth={0}>
      <Typography variant="body2" noWrap>
        {text}
      </Typography>
      {note && (
        <Typography variant="caption" color="text.secondary" fontStyle="italic" noWrap>
          {note}
        </Typography>
      )}
    </Box>
  );
}
